import { Routes, Route } from "react-router-dom";
import Pages from "./pages";
import MainContainer from "./layout/MainContainer";
import PermissionGuard from "./components/PermissionGuard";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/permission-denied" element={<Pages.PermissionDenied />} />

      <Route element={<MainContainer />}>
        <Route
          path="/dashboard"
          element={
            <PermissionGuard module="Dashboard">
              <Pages.Dashboard />
            </PermissionGuard>
          }
        />
        <Route
          path="/reset-password-requests"
          element={<Pages.ResetPasswordRequests />}
        />
        <Route
          path="/manage-users"
          element={
            <PermissionGuard module="Manage Customers">
              <Pages.ManageCustomers />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-users/detail/:id"
          element={
            <PermissionGuard module="Manage Customers">
              <Pages.ManageCustomerDetail />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-users/edit/:id"
          element={
            <PermissionGuard module="Manage Customers">
              <Pages.EditUser />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-shared-accounts"
          element={
            <PermissionGuard module="Shared Account">
              <Pages.ManageSharedAccount />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-shared-accounts/:id"
          element={
            <PermissionGuard module="Shared Account">
              <Pages.ManageSharedAccountDetail />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-budget-categories"
          element={
            <PermissionGuard module="Budget Intelligence">
              <Pages.BudgetCategories />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-alert-configuration"
          element={
            <PermissionGuard module="Budget Intelligence">
              <Pages.AlertsConfiguration />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-revenue"
          element={
            <PermissionGuard module="Manage Revenue">
              <Pages.ManageRevenue />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subadmin"
          element={
            <PermissionGuard module="Manage SubAdmin">
              <Pages.ManageSubadmin />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subadmin/add"
          element={
            <PermissionGuard module="Manage SubAdmin">
              <Pages.AddSubadmin />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subadmin/add/:id"
          element={
            <PermissionGuard module="Manage SubAdmin">
              <Pages.AddSubadmin />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subadmin/view/:id"
          element={
            <PermissionGuard module="Manage SubAdmin">
              <Pages.ViewSubadmin />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subadmin/roles"
          element={
            <PermissionGuard module="Manage SubAdmin">
              <Pages.ManageSubadminRoles />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subadmin/roles/add"
          element={
            <PermissionGuard module="Manage SubAdmin">
              <Pages.AddRole />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subadmin/roles/edit/:id"
          element={
            <PermissionGuard module="Manage SubAdmin">
              <Pages.AddRole />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subadmin/roles/detail/:id"
          element={
            <PermissionGuard module="Manage SubAdmin">
              <Pages.RoleDetail />
            </PermissionGuard>
          }
        />
        <Route
          path="/user-engagement"
          element={
            <PermissionGuard module="Manage Analytics">
              <Pages.UserEngagement />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subscriptions"
          element={
            <PermissionGuard module="Manage Subscriptions">
              <Pages.ManageSubscriptions />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-subscriptions/detail"
          element={
            <PermissionGuard module="Manage Subscriptions">
              <Pages.ManageSubscriptionDetail />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-customer-support"
          element={
            <PermissionGuard module="Manage Customer Support">
              <Pages.ManageCustomerSupport />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-notifications"
          element={
            <PermissionGuard module="Notification Management">
              <Pages.ManageNotifications />
            </PermissionGuard>
          }
        />
        <Route
          path="/voice-library"
          element={
            <PermissionGuard module="AI Behavior Language">
              <Pages.VoiceLibrary />
            </PermissionGuard>
          }
        />
        <Route
          path="/voice-library/add"
          element={
            <PermissionGuard module="AI Behavior Language">
              <Pages.AddVoice />
            </PermissionGuard>
          }
        />
        <Route
          path="/voice-library/edit/:id"
          element={
            <PermissionGuard module="AI Behavior Language">
              <Pages.AddVoice />
            </PermissionGuard>
          }
        />
        <Route
          path="/multilingual-engine"
          element={
            <PermissionGuard module="AI Behavior Language">
              <Pages.MultilngualEngine />
            </PermissionGuard>
          }
        />
        <Route
          path="/mood-mapping"
          element={
            <PermissionGuard module="AI Behavior Language">
              <Pages.MoodMapping />
            </PermissionGuard>
          }
        />
        <Route
          path="/mood-mapping/add-mood-map"
          element={
            <PermissionGuard module="AI Behavior Language">
              <Pages.AddMood />
            </PermissionGuard>
          }
        />
        <Route
          path="/recieved-notifications"
          element={
            <PermissionGuard module="Notification Management">
              <Pages.RecievedNotifications />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-cms"
          element={
            <PermissionGuard module="Manage CMS">
              <Pages.ManageCms />
            </PermissionGuard>
          }
        />
        <Route
          path="/reminder-engine"
          element={
            <PermissionGuard module="Reminder Engine">
              <Pages.ReminderEngine />
            </PermissionGuard>
          }
        />
        <Route
          path="/reminder-engine/add"
          element={
            <PermissionGuard module="Reminder Engine">
              <Pages.AddReminder />
            </PermissionGuard>
          }
        />
        <Route
          path="/hydration/add"
          element={
            <PermissionGuard module="Hydration And Goal">
              <Pages.AddHydration />
            </PermissionGuard>
          }
        />
        <Route
          path="/hydration"
          element={
            <PermissionGuard module="Hydration And Goal">
              <Pages.HydrationGoal />
            </PermissionGuard>
          }
        />
        <Route
          path="/document-processing"
          element={
            <PermissionGuard module="Document Processing">
              <Pages.DocumentProcessing />
            </PermissionGuard>
          }
        />
        <Route
          path="/document-processing/add-document"
          element={
            <PermissionGuard module="Document Processing">
              <Pages.AddDocument />
            </PermissionGuard>
          }
        />
        <Route
          path="/document-processing/edit-document/:id"
          element={
            <PermissionGuard module="Document Processing">
              <Pages.AddDocument />
            </PermissionGuard>
          }
        />
        <Route
          path="/label-recognition"
          element={
            <PermissionGuard module="Label Recognition">
              <Pages.LabelRecognition />
            </PermissionGuard>
          }
        />
        <Route
          path="/shopping-meals"
          element={
            <PermissionGuard module="Shopping Meals">
              <Pages.ShoppingMeals />
            </PermissionGuard>
          }
        />
        <Route
          path="/shopping-meals/sub-categories/:id"
          element={
            <PermissionGuard module="Shopping Meals">
              <Pages.SubCategoriesShopping />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-profile"
          element={
            <PermissionGuard module="Settings">
              <Pages.ManageProfile />
            </PermissionGuard>
          }
        />
        <Route
          path="/smart-messaging"
          element={
            <PermissionGuard module="Manage Analytics">
              <Pages.SmartMessaging />
            </PermissionGuard>
          }
        />
        <Route
          path="/wellness-lifestyle"
          element={
            <PermissionGuard module="Manage Analytics">
              <Pages.WellnessLifestyle />
            </PermissionGuard>
          }
        />
        <Route
          path="/financial-overview"
          element={
            <PermissionGuard module="Manage Analytics">
              <Pages.FinancialOverview />
            </PermissionGuard>
          }
        />
        <Route
          path="/settings"
          element={
            <PermissionGuard module="Settings">
              <Pages.Settings />
            </PermissionGuard>
          }
        />
        <Route
          path="/translation-messaging"
          element={
            <PermissionGuard module="Translation Messaging">
              <Pages.LanguageLibrary />
            </PermissionGuard>
          }
        />
        <Route
          path="/translation-messaging/view"
          element={
            <PermissionGuard module="Translation Messaging">
              <Pages.ViewLanguageLibrary />
            </PermissionGuard>
          }
        />
        <Route
          path="/location-intelligence"
          element={
            <PermissionGuard module="Location Intelligence">
              <Pages.LocationIntelligence />
            </PermissionGuard>
          }
        />
        <Route
          path="/location-intelligence/add-location"
          element={
            <PermissionGuard module="Location Intelligence">
              <Pages.AddLocation />
            </PermissionGuard>
          }
        />
        <Route
          path="/location-intelligence/edit-location/:id"
          element={
            <PermissionGuard module="Location Intelligence">
              <Pages.AddLocation />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-profile/edit"
          element={
            <PermissionGuard module="Settings">
              <Pages.EditProfile />
            </PermissionGuard>
          }
        />
        <Route
          path="/manage-profile/change-password"
          element={
            <PermissionGuard module="Settings">
              <Pages.ChangePassword />
            </PermissionGuard>
          }
        />
      </Route>

      {/* Catch-all route for any invalid URLs */}
      <Route path="*" element={<Pages.PermissionDenied />} />
    </Routes>
  );
};

export default Routing;
